import {
  PublicInvoiceSchema,
  StripePaymentIntentResponseSchema,
  PayPalOrderResponseSchema,
} from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type PublicInvoice = PublicInvoiceSchema;
export type StripePaymentIntent = StripePaymentIntentResponseSchema;
export type PayPalOrder = PayPalOrderResponseSchema;

/**
 * Validate payment token and get invoice data
 * This is used by the public payment page
 */
export const getPublicInvoice = async (token: string): Promise<PublicInvoice> => {
  const response = await apiClient.get<{ invoice: PublicInvoice }>(`/api/public/pay/${token}`);
  return response.data.invoice;
};

/**
 * Initialize Stripe payment
 */
export const initStripePayment = async (
  token: string,
  amount: number,
  payerEmail: string,
  payerName: string,
): Promise<StripePaymentIntent> => {
  const response = await apiClient.post<StripePaymentIntent>("/api/public/pay/stripe", {
    token,
    amount,
    payerEmail,
    payerName,
    provider: "stripe",
  });
  return response.data;
};

/**
 * Initialize PayPal payment
 */
export const initPayPalPayment = async (
  token: string,
  amount: number,
  payerEmail: string,
  payerName: string,
): Promise<PayPalOrder> => {
  const response = await apiClient.post<PayPalOrder>("/api/public/pay/paypal", {
    token,
    amount,
    payerEmail,
    payerName,
    provider: "paypal",
  });
  return response.data;
};

/**
 * Capture PayPal payment after user approval
 */
export const capturePayPalPayment = async (
  token: string,
  orderId: string,
): Promise<{ success: boolean; transactionId: string; amount: number; currency: string }> => {
  const response = await apiClient.post("/api/public/pay/paypal/capture", {
    token,
    orderId,
  });
  return response.data;
};

export default getPublicInvoice;
